module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fABc4EsA.a5383450.woff2";